import React from "react";
import trans from "../../../utils";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { useSelector } from "react-redux";

export default function OfflineConfigSearch({ setSearchQuery, searchQuery }) {
	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};
	const offlineMode = useSelector((state) => state.users.offlineMode);

	return (
		<div className="flex-between">
			<div
				style={{
					color: "#42526E",
					fontSize: "18px",
					fontWeight: "500",
					textTransform: "capitalize",
				}}
			>
				{!offlineMode ? trans("available to cache") : trans("available cached")}
			</div>
			{!offlineMode && (
				<Searchbar
					// eslint-disable-next-line react/style-prop-object
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={searchQuery}
					onChange={handleSearch}
				/>
			)}
		</div>
	);
}
